<template>
  <div class="login container">
    <form class="card-panel" @submit.prevent="login">
      <h2 class="center black-text">Login</h2>
      <div class="field">
        <label for="email">Email</label>
        <input id="email" type="email" v-model="email" />
      </div>
      <div class="field">
        <label for="password">Password</label>
        <input id="password" type="password" v-model="password" />
      </div>
      <p v-if="feedback" class="red-text center">{{ feedback }}</p>
      <div class="field center">
        <button class="btn orange accent-4">Login</button>
      </div>
    </form>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
      feedback: null,
    };
  },
  methods: {
    login() {
      if (this.email && this.password) {
        this.feedback = null;
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then((user) => {
            //console.log(user)
            this.$router.push({ name: "GMap" });
          })
          .catch((err) => {
            this.feedback = err.message;
          });
      } else {
        this.feedback = "Please fill in both fields";
      }
    },
  },
};
</script>

<style>
.login {
  max-width: 500px;
  margin-top: 60px;
}
.login h2 {
  font-size: 2.6em;
}
.login .field {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue